/* The File destination's shell: header, then sections or the drop zone.
 *
 * Fills the destination area as a flex column so the row list scrolls inside
 * it rather than growing the page and pushing the bottom nav off-screen. That
 * failure mode has shipped twice in this arc (see shellLayout.test.ts in both
 * apps), so the chain is explicit: root flex:1/min-height:0 -> body
 * flex:1/min-height:0/overflow-y:auto. */

.root {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-8);
  /* flex: none so the header keeps its height when the body is full. */
  flex: none;
  padding: var(--spacing-12) var(--spacing-16) var(--spacing-16);
}

/* Host status line (no device, file too large, keep-panel-open). Shares the
 * rows' gutter so it lines up with the cards instead of hugging the edge, and
 * sits flush under the header rather than adding a second gap. */
.banner {
  flex: none;
  padding: 0 var(--spacing-16) var(--spacing-8);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  /* min-height: 0 is required for a flex child to shrink below its content;
   * without it overflow-y never engages and the column grows instead. */
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 var(--spacing-16) var(--spacing-16);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
}

.sectionHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-8);
  min-height: 24px;
}

/* Notes about in-flight work, below the rows they describe. Inside `.body` so
 * it scrolls with the list rather than pinning over it. */
.footnote {
  flex: none;
  padding-top: var(--spacing-4);
}

/* Deliberately not named `.list`: SidePanelNotificationList's `.list > li`
 * rule forces its children into a centred flex column, and a card row must
 * stay a row. jsdom cannot catch that regression, so the name is the guard. */
.rows {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Visually hidden but still clickable via ref — `display: none` breaks
 * `.click()` in some engines. */
.input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
